import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Header: React.FC = () => {
  const { isAuthenticated, logout } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const navLinks = [
    { to: '/', label: 'الرئيسية' },
    { to: '/ads', label: 'السوق' },
    { to: '/categories', label: 'التصنيفات' },
    { to: '/services', label: 'الخدمات' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <header style={{ background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.08)', position: 'sticky', top: 0, zIndex: 50, fontFamily: "'Cairo', sans-serif" }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 60 }}>
          {/* Logo */}
          <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}>
            <span style={{ fontSize: 24, fontWeight: 700, color: '#1976D2', fontFamily: "'Cairo', sans-serif" }}>الجلب</span>
            <span style={{ fontSize: 11, color: '#9E9E9E', marginTop: 4 }}>سوق الحلال</span>
          </Link>

          {/* Desktop Nav */}
          <nav style={{ display: 'flex', alignItems: 'center', gap: 4, marginRight: 30, marginLeft: 30 }} className="desktop-nav">
            {navLinks.map(link => (
              <Link
                key={link.to}
                to={link.to}
                style={{
                  padding: '8px 16px',
                  borderRadius: 8,
                  fontSize: 14,
                  fontWeight: 600,
                  color: isActive(link.to) ? '#1976D2' : '#616161',
                  background: isActive(link.to) ? '#E3F2FD' : 'transparent',
                  textDecoration: 'none',
                  transition: 'all 0.2s',
                  fontFamily: "'Cairo', sans-serif",
                }}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Search */}
          <div style={{ flex: 1, maxWidth: 400, margin: '0 16px' }} className="desktop-search">
            <input
              type="text"
              placeholder="ابحث عن مواشي، خدمات..."
              onFocus={() => navigate('/search')}
              style={{
                width: '100%',
                background: '#F5F5F5',
                border: '1.5px solid #E0E0E0',
                borderRadius: 8,
                padding: '9px 16px',
                fontSize: 13,
                fontFamily: "'Cairo', sans-serif",
                outline: 'none',
                color: '#424242',
              }}
            />
          </div>

          {/* Actions */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} className="desktop-actions">
            {isAuthenticated ? (
              <>
                <Link to="/my/favorites" style={{ padding: '6px 12px', fontSize: 13, color: '#757575', textDecoration: 'none', fontWeight: 500, fontFamily: "'Cairo', sans-serif" }}>المفضلة</Link>
                <Link to="/my/conversations" style={{ padding: '6px 12px', fontSize: 13, color: '#757575', textDecoration: 'none', fontWeight: 500, fontFamily: "'Cairo', sans-serif" }}>المحادثات</Link>
                <Link to="/my/notifications" style={{ padding: '6px 12px', fontSize: 13, color: '#757575', textDecoration: 'none', fontWeight: 500, fontFamily: "'Cairo', sans-serif" }}>الإشعارات</Link>
                <Link to="/my/profile" style={{ padding: '6px 12px', fontSize: 13, color: '#757575', textDecoration: 'none', fontWeight: 500, fontFamily: "'Cairo', sans-serif" }}>حسابي</Link>
              </>
            ) : (
              <Link to="/login" style={{ padding: '6px 16px', fontSize: 13, color: '#1976D2', textDecoration: 'none', fontWeight: 600, fontFamily: "'Cairo', sans-serif" }}>دخول</Link>
            )}
            <Link
              to="/ads/create"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                background: '#1976D2',
                color: '#fff',
                padding: '8px 20px',
                borderRadius: 8,
                fontSize: 13,
                fontWeight: 600,
                textDecoration: 'none',
                fontFamily: "'Cairo', sans-serif",
                transition: 'background 0.2s',
              }}
            >
              + أضف إعلان
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="mobile-menu-btn"
            style={{ display: 'none', background: 'none', border: 'none', fontSize: 22, color: '#616161', cursor: 'pointer', padding: 8 }}
          >
            {mobileMenuOpen ? '✕' : '☰'}
          </button>
        </div>

        {/* Mobile Search */}
        <div className="mobile-search" style={{ display: 'none', paddingBottom: 12 }}>
          <input
            type="text"
            placeholder="ابحث عن مواشي، خدمات..."
            onFocus={() => navigate('/search')}
            style={{
              width: '100%',
              background: '#F5F5F5',
              border: '1.5px solid #E0E0E0',
              borderRadius: 8,
              padding: '9px 16px',
              fontSize: 13,
              fontFamily: "'Cairo', sans-serif",
              outline: 'none',
            }}
          />
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div style={{ background: '#fff', borderTop: '1px solid #E0E0E0', padding: '12px 20px' }} className="mobile-menu">
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              onClick={() => setMobileMenuOpen(false)}
              style={{
                display: 'block',
                padding: '10px 0',
                fontSize: 15,
                fontWeight: isActive(link.to) ? 700 : 500,
                color: isActive(link.to) ? '#1976D2' : '#424242',
                textDecoration: 'none',
                borderBottom: '1px solid #F5F5F5',
                fontFamily: "'Cairo', sans-serif",
              }}
            >
              {link.label}
            </Link>
          ))}
          {isAuthenticated ? (
            <>
              <Link to="/my/ads" onClick={() => setMobileMenuOpen(false)} style={{ display: 'block', padding: '10px 0', fontSize: 15, color: '#424242', textDecoration: 'none', borderBottom: '1px solid #F5F5F5', fontFamily: "'Cairo', sans-serif" }}>إعلاناتي</Link>
              <Link to="/my/favorites" onClick={() => setMobileMenuOpen(false)} style={{ display: 'block', padding: '10px 0', fontSize: 15, color: '#424242', textDecoration: 'none', borderBottom: '1px solid #F5F5F5', fontFamily: "'Cairo', sans-serif" }}>المفضلة</Link>
              <Link to="/my/conversations" onClick={() => setMobileMenuOpen(false)} style={{ display: 'block', padding: '10px 0', fontSize: 15, color: '#424242', textDecoration: 'none', borderBottom: '1px solid #F5F5F5', fontFamily: "'Cairo', sans-serif" }}>المحادثات</Link>
              <Link to="/my/profile" onClick={() => setMobileMenuOpen(false)} style={{ display: 'block', padding: '10px 0', fontSize: 15, color: '#424242', textDecoration: 'none', borderBottom: '1px solid #F5F5F5', fontFamily: "'Cairo', sans-serif" }}>حسابي</Link>
              <button onClick={() => { logout(); setMobileMenuOpen(false); }} style={{ display: 'block', width: '100%', textAlign: 'right', padding: '10px 0', fontSize: 15, color: '#F44336', background: 'none', border: 'none', cursor: 'pointer', fontFamily: "'Cairo', sans-serif" }}>خروج</button>
            </>
          ) : (
            <Link to="/login" onClick={() => setMobileMenuOpen(false)} style={{ display: 'block', padding: '10px 0', fontSize: 15, fontWeight: 600, color: '#1976D2', textDecoration: 'none', fontFamily: "'Cairo', sans-serif" }}>تسجيل الدخول</Link>
          )}
        </div>
      )}

      <style>{`
        @media(max-width:768px){
          .desktop-nav,.desktop-search,.desktop-actions{display:none!important}
          .mobile-menu-btn,.mobile-search{display:block!important}
        }
      `}</style>
    </header>
  );
};

export default Header;
